import React from 'react'
import { RequirementCardContainer } from './styles'
import { FormikRadioButtonGroup } from 'particles/RadioButton/Group'
import { BaseFieldProps } from '.'
import FieldTitleAndSubTitle from './FieldTitleAndSubTitle'
import Label from 'particles/Label'

interface OptionsState<T = any> {
    label: string
    value: T
}

interface RadioGroupFieldProps extends BaseFieldProps {
    onClose?: () => void
    className?: string
    options: OptionsState[]
    isDisplayRow?: boolean
    isReadOnly?: boolean
    width?: string
    isCard?: boolean
    isDisable?: boolean
    subLabel?: string
    identifier?: string
}
const RadioGroupField: React.FC<RadioGroupFieldProps> = ({
    name = '',
    options,
    title,
    subtitle,
    isRequired = false,
    className,
    onClose,
    isDisplayRow = false,
    isReadOnly = false,
    width,
    isCard = false,
    isDisable = false,
    subLabel,
    identifier,
}) => {
    return (
        <RequirementCardContainer className={className} width={width} isCard={isCard}>
            <FieldTitleAndSubTitle
                isRequired={isRequired}
                onClose={onClose}
                title={title}
                subtitle={subtitle}
                isReadOnly={isReadOnly}
                identifier={identifier}
            />
            {subLabel && <Label title={subLabel} isRequired={false} className="sub-label" />}
            <FormikRadioButtonGroup
                name={name}
                options={options}
                orientation={isDisplayRow ? 'horizontal' : 'vertical'}
                isReadOnly={isReadOnly}
                isDisabled={isDisable}
                size="s"
            />
        </RequirementCardContainer>
    )
}
export default RadioGroupField
